import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import SeoHead from "@/components/feature/SeoHead";
import { faqs, kuaibaoList } from "@/mocks/kuaibao";
import type { KuaibaoItem } from "@/types/kuaibao";
import Hero from "./components/Hero";
import TrendBoard from "./components/TrendBoard";
import LatestFeed from "./components/LatestFeed";
import CategoryGrid from "./components/CategoryGrid";
import StepsSection from "./components/StepsSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

const sorted = [...(kuaibaoList as KuaibaoItem[])].sort((a, b) => b.heat - a.heat).slice(0, 10);

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51.cg 今日吃瓜单",
    url: "https://hizmfjw.cn/",
    inLanguage: "zh-CN",
    description:
      "51.cg今日吃瓜单聚合全网热点，吃瓜快报速览模式，一分钟刷完全部热点，今日瓜单与快报总览一站集齐。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://hizmfjw.cn/kuaibao?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51.cg 今日吃瓜单",
    url: "https://hizmfjw.cn/",
    email: "hello@51cg.example",
    description: "以榜单排序与一句话速览为核心的热点速览站。",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日瓜单榜",
    itemListElement: sorted.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.title,
      url: `https://hizmfjw.cn/kuaibao/${item.slug}`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#subscribe") {
      const el = document.getElementById("subscribe");
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
      }
    }
  }, [location.hash]);

  return (
    <>
      <SeoHead
        title="51.cg今日吃瓜单 - 吃瓜快报一分钟刷完全部热点"
        description="51.cg今日吃瓜单上线，吃瓜快报速览模式开启。今日瓜单与快报总览一站集齐，按热度排好序，一分钟刷完全部热点，快速跟上吃瓜节奏，省时省力不迷路。"
        keywords="51.cg,51.cg今日吃瓜单,51.cg吃瓜快报,51.cg一分钟吃瓜,51.cg吃瓜总览"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteNavbar overlay />
      <main className="w-full">
        <Hero />
        <TrendBoard />
        <LatestFeed />
        <CategoryGrid />
        <StepsSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}